import classNames from "classnames/bind";
import { ResolvedNavItem } from "resolvers/base/navigationResolver";
import { StepView } from "../../interfaces";
import { Stock } from "../../Stock";
import styles from "./MainMenuList.module.scss";

const cx = classNames.bind(styles);

type Props = {
    handleNextStepView: (stepView: StepView) => void;
    items: ResolvedNavItem[];
    className?: string;
    title: string;
    showStock?: boolean;
    priority: "primary" | "secondary";
};

export const MainMenuList = ({
    handleNextStepView,
    items,
    className = "",
    title,
    showStock = false,
    priority,
}: Props) => {
    const handleItemClick = (item: ResolvedNavItem): void => {
        handleNextStepView({
            stepIndex: 1,
            stepData: item,
        });
    };

    const handleNextStepViewMegaMenu = (item: ResolvedNavItem): void => {
        handleNextStepView({
            stepIndex: 2,
            stepData: item,
        });
    };

    return (
        <div className={cx("menu", priority, className)}>
            {title && <span className={cx("menuTitle")}>{title}</span>}
            <ul role="menu" aria-labelledby="menubutton" className={cx("list")}>
                {items.map(({ id, text, link, subMenuId, megaMenuId }) => {
                    const isMegaMenu = !!megaMenuId;

                    const handleNextStepClick = isMegaMenu
                        ? handleNextStepViewMegaMenu
                        : handleItemClick;

                    return (
                        <li key={id} role="menuitem" className={cx("listItem", priority)}>
                            {!!text && !link && (
                                <div className={cx("listItemTextWrapper")}>
                                    <span
                                        className={cx("listItemText", priority)}
                                        onClick={() => {
                                            handleNextStepClick({
                                                link,
                                                subMenuId,
                                                megaMenuId,
                                                text,
                                            });
                                        }}
                                    >
                                        {text}
                                    </span>
                                    {showStock && <Stock stockNumber={1234} />}
                                </div>
                            )}
                            {!!text && !!link && (
                                <div className={cx("listItemTextWrapper")}>
                                    <span
                                        className={cx("listItemText", priority)}
                                        onClick={() => {
                                            handleNextStepClick({
                                                link,
                                                subMenuId,
                                                text,
                                                megaMenuId,
                                            });
                                        }}
                                    >
                                        {text}
                                    </span>
                                </div>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
